import { TaskData } from '../types/task';
import { TaskTypes } from '../types/taskTypes';

export class EvidenceOrder {
  taskType: TaskTypes;
  taskData: TaskData;

  constructor(taskType: TaskTypes, taskData: TaskData) {
    this.taskType = taskType;
    this.taskData = taskData;
  }
}
